import create from './create';
import edit from './edit';
import list from './list';

export default {
  create,
  edit,
  list
};
